import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../styles";

export const statItemStyles = style({
  position: "relative",
  display: "flex",
  flex: "1 0 28%",
  justifyContent: "center",
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      flexBasis: "5%",
    },
  },
  selectors: {
    // check for if the parent ul does not have a 5th <li>  (aka only has 4 items)
    "ul:not(:has(> li:nth-child(5))) &": {
      flex: "1 0 25%",
    },
    "&:not(:last-child)::after": {
      position: "absolute",
      top: "15%",
      insetInlineEnd: 0,
      borderInlineStart: `1px solid ${vars.colors.outlineVariant}`,
      height: 32,
      content: '""',
    },
  },
});

export const statWrapper = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const statTitle = style({
  textAlign: "center",
  textWrap: "nowrap",
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.xs,
});

export const statValue = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.m,
});

export const subValue = style({
  textWrap: "nowrap",
  fontSize: vars.fontSizes.body.xs,
});
